/**
 * salter.service.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import { ConfigurationService } from "../configuration/configuration.service";

/**
 * The {@link Salter} is responsible for building the application salt and
 * appending it to strings.
 */
@Injectable()
export class Salter {
  constructor (protected config : ConfigurationService) {}

  /**
   * Decrypt a XOR-encoded array of signed ints, given a particular start value
   */
  private decryptXOR (startByte : number, remaining : number[]) : Int8Array
  {
    // The salt is stored with a XOR-encoding where each byte must be XORed
    // against the previous.
    return new Int8Array(remaining).map(
      (value : number, index : number) => {
        // tslint:disable-next-line:no-bitwise
        const output : number = value ^ startByte;
        startByte = value;
        return output;
      }
    );
  }

  /**
   * Use a byte array to decrypt the application salt
   */
  private buildSaltString (saltNums : number[]) : string
  {
    if (!saltNums)
    {
      console.warn(this.config.protocol);
      throw new Error("Cannot build salt string, no salt defined!");
    }
    const startByte : number = 0xb7;
    const saltBytes : Int8Array = this.decryptXOR(startByte, saltNums);
    // NOTE: Using fromCharCode would not be sufficient to convert bytes to
    // UTF-16, but we absolutely know our salt is ASCII (it's stored as octets)
    // so we can be sure that each entry is 1 code point and less than 2^16.
    return saltBytes.reduce(
      (prev : string, current : number) => prev + String.fromCharCode(current),
      ""
    );
  }

  /**
   * Append the application salt to a string
   */
  public salt (plaintext : string) : string
  {
    return this.buildSaltString(this.config.protocol.applicationSalt)
      + plaintext;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/auth/salter.service.ts